<div class="loading-overlay d-flex justify-content-center align-items-center">
    <div class="spinner"></div>
  </div>
  